import Accordion from '../../../../shared/components/Accordion';
import SectionHeader from '../../../../shared/components/SectionHeader';

import { useRootSelector } from '../../../../../../store/hooks';
import { selectPricingKeyInformationSection } from '../../../../store/features/products';
import ContactUsWidget from '../../../../shared/components/ContactUsWidget';

export default function KeyInformationSection() {
  const {
    title,
    firstAccordionBlockOpen,
    items,
    showContactUs,
    contactUsTitle,
    contactUsSubTitle,
    contactUsEmail,
  } = useRootSelector(selectPricingKeyInformationSection);

  return (
    <>
      <SectionHeader
        heading={title}
        headingProps={{
          paletteColorName: 'brandSecondary',
        }}
        sx={{
          mb: 2,
        }}
      />
      {items.length > 0 && (
        <Accordion
          enableSingleExpand
          items={items}
          defaultSingleExpand={
            firstAccordionBlockOpen ? items[0].id : undefined
          }
        />
      )}
      {showContactUs && (
        <ContactUsWidget
          title={contactUsTitle}
          subTitle={contactUsSubTitle}
          email={contactUsEmail}
          sx={{ mt: 2 }}
        />
      )}
    </>
  );
}
